import type { DevView } from './DevDock';

export type MainRuntimeRoute = 'game' | 'worldReview' | 'rigReview' | 'assetView' | 'trackReview';
export type MainScenePanelMode = 'game' | 'map';

export interface MainDevRuntime {
  route: MainRuntimeRoute;
  devMode: boolean;
  productionLike: boolean;
  initialDockView: DevView;
  scenePanelMode: MainScenePanelMode;
}

function hasProductionLikeFlag(params: URLSearchParams): boolean {
  return params.has('prod') || params.has('production') || params.has('playtest');
}

export function resolveMainDevRuntime(params: URLSearchParams, isDevEnv: boolean): MainDevRuntime {
  if (params.has('worldReview')) {
    return {
      route: 'worldReview',
      devMode: true,
      productionLike: false,
      initialDockView: 'map',
      scenePanelMode: 'map',
    };
  }

  if (params.has('rigReview')) {
    return {
      route: 'rigReview',
      devMode: true,
      productionLike: false,
      initialDockView: 'rig',
      scenePanelMode: 'game',
    };
  }

  if (params.has('assetView')) {
    return {
      route: 'assetView',
      devMode: true,
      productionLike: false,
      initialDockView: 'assets',
      scenePanelMode: 'game',
    };
  }

  if (params.has('trackReview')) {
    return {
      route: 'trackReview',
      devMode: true,
      productionLike: false,
      initialDockView: 'map',
      scenePanelMode: 'map',
    };
  }

  const isMapAlias = params.has('devView');
  const productionLike = hasProductionLikeFlag(params);
  return {
    route: 'game',
    devMode: !productionLike && (params.has('dev') || isMapAlias || (isDevEnv && !params.has('nodev'))),
    productionLike,
    initialDockView: isMapAlias ? 'map' : 'game',
    scenePanelMode: isMapAlias ? 'map' : 'game',
  };
}
